export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=ba4c01f8&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/materials/materials-vendors/index.vue?vue&type=template&id=ba4c01f8&
// module id = 1509
// module chunks = 0